export default "__VITE_ASSET__BVtB1TPs__"